import HC from "@/lib/compute";
import { fint, bandM, IND_COLOR } from "@/lib/ui";
import { Legend } from "@/components/dash/Bits";

function WCell({ v, sc }) {
  if (v === null || v === undefined) return <span className="score-cell none"><b>—</b></span>;
  const bb = sc !== null && sc !== undefined ? bandM(sc) : null;
  const tip = `Weightage <b class='num'>${v.toFixed(2)}</b>${bb ? `<br>Colour: indicator score <b class='num'>${sc.toFixed(2)}</b> out of 5 (${bb})` : ""}`;
  return <span className={`score-cell ${bb || "raw"}`} data-tip={tip}><b>{v.toFixed(2)}</b></span>;
}

export function IndCard({ o }) {
  const tools = o.tools, multi = tools.length > 1;
  return (
    <div className="card span-7"><div className="card-head"><div><h2>Indicator wise Weightage Score</h2>
      <p className="sub">As in Power BI: average of score × parameter weight, so the numbers are not out of 5. Each cell is coloured by that indicator's own score out of 5 (the same score as the Indicator profile), so the colours follow the rating bands. Hover a cell for both values.</p></div></div>
      <div className="tbl-wrap"><table data-testid="weightage-table"><thead><tr><th>Indicator</th>{tools.map(t => <th key={t} className="c">{t}</th>)}{multi ? <th className="c">All tools</th> : null}</tr></thead><tbody>
        {o.indRows.length ? o.indRows.map(r => (
          <tr key={r.ind}><td className="ind-cell"><span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "2px", background: IND_COLOR[r.ind], marginRight: "8px" }}></span>{r.ind}</td>
            {tools.map(t => <td key={t} className="c"><WCell v={r.cells[t]} sc={r.scoreCells && r.scoreCells[t]} /></td>)}
            {multi ? <td className="c"><WCell v={r.all} sc={r.scoreAll} /></td> : null}</tr>
        )) : <tr><td colSpan={9} className="empty">No indicator data for this selection.</td></tr>}
      </tbody></table></div></div>
  );
}

function PCell({ c }) {
  if (!c || c.v === null) return <span className="muted num" style={{ fontSize: "12px" }}>—{c && c.resp ? " (" + fint(c.resp) + ")" : ""}</span>;
  const bb = bandM(c.v), over = c.v > 5;
  const tip = `<b>${c.v.toFixed(2)}</b> from <span class='num'>${fint(c.resp)}</span> responses<br>Sources: ${c.srcs.map(s => HC.SRC_LABEL[s]).join(", ") || "—"}${over ? "<br><b>Above 5:</b> Power BI added two sources together" : ""}`;
  return <span className={`score-cell ${over ? "raw" : bb}`} data-tip={tip}><b>{c.v.toFixed(2)}{over ? " ▲" : ""}</b><span>({fint(c.resp)})</span></span>;
}

export function ParCard({ o }) {
  const tools = o.tools, allTools = tools.length > 1;
  let lastInd = null;
  return (
    <div className="card span-12"><div className="card-head"><div><h2>Parameters wise Score</h2><p className="sub">Average score with the number of responses in brackets, exactly as Power BI calculates it.</p></div><Legend /></div>
      <div className="tbl-wrap"><table className="stick1" data-testid="parameters-table"><thead><tr><th className="hide-sm">Indicator</th><th className="par-h">Parameter</th><th className="r hide-sm">Weight</th>{tools.map(t => <th key={t} className="c">{t}</th>)}{allTools ? <th className="c">All tools</th> : null}</tr></thead><tbody>
        {o.paramRows.length ? o.paramRows.map(r => {
          const first = r.ind !== lastInd; lastInd = r.ind;
          return (
            <tr key={r.ind + "|" + r.par}><td className="ind-cell hide-sm">{first ? r.ind : ""}</td><td className="par-name">{first ? <span className="ind-sm">{r.ind}</span> : null}{r.par}{r.type === "Qualitative" ? <span className="tag">Study closure</span> : null}</td><td className="r num muted hide-sm">{r.w !== undefined ? r.w.toFixed(2) : "—"}</td>
              {tools.map(t => <td key={t} className="c"><PCell c={r.cells[t]} /></td>)}{allTools ? <td className="c"><PCell c={r.all} /></td> : null}</tr>
          );
        }) : <tr><td colSpan={9} className="empty">No parameter data for this selection.</td></tr>}
      </tbody></table></div></div>
  );
}
